import { LIMITE_6SM, LIMITE_10SM, FAIXAS } from './constantes';

export function calcularRendaEfetiva(lead) {
  var familiar = lead.renda_familiar;
  var pessoal = lead.renda_pessoal;

  if (familiar != null && familiar > 0) {
    return { valor: familiar, tipo: 'Familiar' };
  }
  if (pessoal != null && pessoal > 0) {
    return { valor: pessoal, tipo: 'Pessoal' };
  }
  return { valor: null, tipo: 'N/I' };
}

export function classificarFaixa(rendaEfetiva) {
  if (rendaEfetiva == null) return 'NAO_INFORMADA';
  if (rendaEfetiva <= LIMITE_6SM) return 'ATE_6SM';
  if (rendaEfetiva <= LIMITE_10SM) return 'DE_6_A_10SM';
  return 'LIVRE';
}

export function getLabelFaixa(chave) {
  var faixa = FAIXAS[chave];
  return faixa ? faixa.label : chave;
}

export function isPastaCompletaSemRenda(lead) {
  var docCompleta =
    lead.documentacao_completa === 1 || lead.documentacao_completa === true;
  var renda = calcularRendaEfetiva(lead);
  return docCompleta && renda.valor == null;
}

export function segmentarDados(dados) {
  if (!dados || dados.length === 0) {
    return {
      todos: [],
      ate6sm: [],
      de6a10sm: [],
      livre: [],
      naoInformada: [],
      contagens: { todos: 0, ate6sm: 0, de6a10sm: 0, livre: 0, naoInformada: 0 },
      pastaCompletaSemRenda: 0,
    };
  }

  var ate6sm = [];
  var de6a10sm = [];
  var livre = [];
  var naoInformada = [];
  var pastaCompletaSemRenda = 0;
  var vendasPorFaixa = { ate6sm: 0, de6a10sm: 0, livre: 0, naoInformada: 0 };

  dados.forEach(function(lead) {
    var renda = calcularRendaEfetiva(lead);
    var faixa = classificarFaixa(renda.valor);

    lead._renda_efetiva = renda.valor;
    lead._tipo_renda = renda.tipo;
    lead._faixa = faixa;
    lead._pasta_completa_sem_renda = isPastaCompletaSemRenda(lead);

    if (lead._pasta_completa_sem_renda) {
      pastaCompletaSemRenda++;
    }

    var qtdVendas = lead.qtd_vendas || 0;

    switch (faixa) {
      case 'ATE_6SM':
        ate6sm.push(lead);
        vendasPorFaixa.ate6sm += qtdVendas;
        break;
      case 'DE_6_A_10SM':
        de6a10sm.push(lead);
        vendasPorFaixa.de6a10sm += qtdVendas;
        break;
      case 'LIVRE':
        livre.push(lead);
        vendasPorFaixa.livre += qtdVendas;
        break;
      case 'NAO_INFORMADA':
        naoInformada.push(lead);
        vendasPorFaixa.naoInformada += qtdVendas;
        break;
      default:
        break;
    }
  });

  var totalVendas = vendasPorFaixa.ate6sm + vendasPorFaixa.de6a10sm + vendasPorFaixa.livre + vendasPorFaixa.naoInformada;

  return {
    todos: dados,
    ate6sm: ate6sm,
    de6a10sm: de6a10sm,
    livre: livre,
    naoInformada: naoInformada,
    contagens: {
      todos: dados.length,
      ate6sm: ate6sm.length,
      de6a10sm: de6a10sm.length,
      livre: livre.length,
      naoInformada: naoInformada.length,
    },
    vendas: vendasPorFaixa,
    totalVendas: totalVendas,
    pastaCompletaSemRenda: pastaCompletaSemRenda,
  };
}
